export default "__VITE_ASSET__Biy09ic2__"